<ion-header>
  <ion-toolbar class="gradient-primary-right">
    <ion-buttons slot="start">
      <ion-button (click)="back()">
        <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      <ng-container *ngIf="!upgradeTrial && !upgradeMode">{{ 'ACCOUNTS.premium.lbl.go_premium' | translate }}</ng-container>
      <ng-container *ngIf="upgradeMode && !upgradeTrial">{{ 'ACCOUNTS.premium.lbl.account_upgrade' | translate }}</ng-container>
      <ng-container *ngIf="upgradeTrial && !upgradeMode">{{  'ACCOUNTS.premium.lbl.account_upgrade' | translate }}</ng-container>
    </ion-title>
  </ion-toolbar>
  <ion-toolbar class="gradient-primary-right ion-no-padding">
    <app-news-card-slide class="full-width" [newsCardSlideType]="'account_product'" [setReady]="ready" (clickAction)="validateVoucher($event, true)"></app-news-card-slide>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding-vertical" color="light">
  <div class="content-div">
    <ng-container *ngFor="let product of accountProductList; let index = index;">
      <ng-container *ngIf="(!upgradeMode || product?.productId === 'wedding_account_full') && (!voucher?.productId || voucher.productId === product?.productId) && (!bulkMode || product?.productId === 'wedding_account_full')">
        <ion-card class="margin-10 ion-padding" [color]="!bulkMode && productId === product.productId ? 'tertiary' : 'white'" (click)="selectPackage(product.productId)" button>
          <ion-icon class="icon-recommend" src="./assets/wedding/icon/subscription/recommended.svg" *ngIf="product?.productId === 'wedding_account_full' && !bulkMode"></ion-icon>
          <ion-item class="ion-item-no-padding product-item background-transparent" lines="none">
            <ion-label class="line-100 info-label ion-text-wrap" color="dark">
              <div class="ion-text-wrap">
                <ion-text class="font-14 font-med">{{ 'PRODUCT.account.' + product.productId + '.short' | translate }}</ion-text>
                <ng-container *ngIf="voucher?.voucherId && voucher?.enable && voucher?.blastCredit">
                  <ion-text class="font-14 font-med" color="danger">&nbsp;+&nbsp;{{ voucher.blastCredit }} {{ 'BLAST.credit.title' | translate }}</ion-text>
                </ng-container>
              </div>
              <div class="product-intro-div"><ion-text class="font-10">{{ 'PRODUCT.account.' + product.productId + '.info' | translate }}</ion-text></div>
            </ion-label>
            <ion-item class="price-item background-transparent ion-item-no-padding" slot="end" lines="none" *ngIf="!bulkMode">
              <ion-label class="ion-no-margin">
                <ng-container *ngIf="!upgradeMode">
                  <div *ngIf="productPrice?.[product?.productId] as productPrice">
                    <ion-text class="font-12 font-med" *ngIf="oriPrice?.[product?.productId] as oriProductPrice">
                      <ng-container *ngIf="productPrice?.amount && productPrice?.amount === oriProductPrice?.amount else systemDiscountBlock">
                        {{ productPrice.amount | currency: productPrice.currency: 'symbol' }}
                      </ng-container>
                      <ng-template #systemDiscountBlock>
                        <div>
                          <div class="ion-text-center">
                            <div><ion-text class="font-12" color="danger">{{ productPrice.amount | currency: productPrice.currency: 'symbol' }}</ion-text></div>
                            <div class="font-10 strikethrough ion-text-center">{{ oriProductPrice.amount | currency: oriProductPrice.currency: 'symbol' }}</div>
                          </div>
                        </div>
                      </ng-template>
                    </ion-text>
                  </div>
                </ng-container>
                <ng-container *ngIf="upgradeMode">
                  <div class="ion-text-left" *ngIf="upgradePrice?.[product?.productId] as upgradePrice">
                    <ion-text class="font-12 font-med" >
                      {{ upgradePrice.amount | currency: upgradePrice.currency: 'symbol' }}
                    </ion-text>
                  </div>
                </ng-container>
                <div class="ion-text-wrap ion-text-center line-100">
                  <ion-text class="unit font-8">{{ 'PRODUCT.account.per_wedding' | translate }}</ion-text>
                </div>
              </ion-label>
            </ion-item>
            <ion-item slot="end" class="background-transparent ion-no-margin ion-item-no-padding" lines="none" *ngIf="bulkMode">
              <ion-input class="qty-input ion-text-center ion-no-padding" min="0" type="number" inputmode="numeric" [(ngModel)]="bulkQty[product.productId]" (ionChange)="setupItemList()" [tabindex]="index">
                <ion-button class="qty-btn" slot="start" (click)="minusQty(product.productId)" fill="clear">
                  <ion-icon slot="icon-only" name="remove"></ion-icon>
                </ion-button>
                <ion-button class="qty-btn" slot="end" (click)="addQty(product.productId)" fill="clear">
                  <ion-icon slot="icon-only" name="add"></ion-icon>
                </ion-button>
              </ion-input>
            </ion-item>
          </ion-item>
        </ion-card>
      </ng-container>
    </ng-container>
    
    <ion-item class="ion-margin-top" color="light" lines="none">
      <ion-text class="font-14 full-width ion-no-margin" color="dark">{{ 'LBL.currency' | translate }}</ion-text>
      <ion-select justify="end" [(ngModel)]="currency" (ionChange)="setupItemList()" [disabled]="upgradeMode" slot="end">
        <ion-select-option *ngFor="let value of productCurrencyList" [value]="value">
          {{ value }}
        </ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item color="light" lines="none" *ngIf="productId || totalQty">
      <ion-label class="font-14" color="dark">
        {{ 'LBL.subtotal' | translate }}
      </ion-label>
      <ion-text class="font-14" color="dark" slot="end">
        <ng-container *ngIf="subtotal">{{ subtotal | currency : currency : 'symbol' }}</ng-container>
        <ng-container *ngIf="!subtotal">{{ 'PAYMENT.type.free' | translate }}</ng-container>
      </ion-text>
    </ion-item>
  
    <ion-item color="light" lines="none" *ngIf="bulkMode && bulkDiscount && totalQty">
      <ion-label class="font-14" color="dark">
        {{ 'LBL.discount' | translate }} ({{ bulkDiscountRate * 100 }}%)
      </ion-label>
      <ion-text class="font-14" color="dark" slot="end">
        - 
        {{ bulkDiscount | currency : currency : 'symbol' }}
      </ion-text>
    </ion-item>
    
    <ion-item color="light" lines="none" (click)="presentVoucherInputModal(voucherId)">
      <ion-label class="font-14 font-underline" color="dark">
        <ng-container  *ngIf="!voucherId || !voucher?.voucherId || !voucherDiscount">
          {{ 'VOUCHER.btn.apply' | translate }}
        </ng-container>
        <ng-container *ngIf="voucherId && voucher?.voucherId && voucherDiscount">
          {{ 'VOUCHER.lbl.voucher' | translate }} ({{ voucherId }})
        </ng-container>
      </ion-label>
      <ng-container *ngIf="voucherId && voucher?.voucherId && voucherDiscount">
        <ion-text class="font-14" color="dark" slot="end">
          - 
          {{ voucherDiscount | currency : currency : 'symbol' }}
        </ion-text>
      </ng-container>
    </ion-item>
  
    <ion-item color="light" lines="none" (click)="presentReferralModal(referralCode)" *ngIf="!voucher?.disableReferral">
      <ion-label class="font-14 font-underline" color="dark">
        <ng-container  *ngIf="!referralCode || !referralRate">
          {{ 'REFERRAL.btn.apply' | translate }}
        </ng-container>
        <ng-container *ngIf="referralCode && referralRate">
          {{ 'MENU.referral' | translate }} ({{ referralCode }})
        </ng-container>
      </ion-label>
      <ng-container *ngIf="referralCode && referralRate">
        <ion-text class="font-14" color="dark" slot="end">
          - 
          {{ referralDiscount | currency : currency : 'symbol' }}
        </ion-text>
      </ng-container>
    </ion-item>
  
    <ng-container *ngIf="!upgradeTrial && !upgradeMode">
      <ion-item color="light" lines="none" *ngIf="!bulkMode">
        <!-- <ion-label class="ion-text-wrap ion-no-margin"></ion-label> -->
        <ion-toggle [(ngModel)]="giftMode" color="success">{{ 'PRODUCT.btn.gift' | translate }}</ion-toggle>
      </ion-item>
      <ion-item color="light" lines="none" *ngIf="voucher?.maxQty !== 1 && !giftMode && (!voucher?.minQty || voucher?.minQty === 1)">
        <!-- <ion-label class="ion-text-wrap ion-no-margin">{{ 'PRODUCT.btn.bulk' | translate }}</ion-label> -->
        <ion-toggle [(ngModel)]="bulkMode" (ionChange)="toggleBulkMode()" color="success">{{ 'PRODUCT.btn.bulk' | translate }}</ion-toggle>
      </ion-item>
    </ng-container>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar color="white">
    <div class="content-div">
      <ion-item class="total-item ion-item-no-padding ion-margin background-transparent" lines="none" *ngIf="totalQty && itemList?.length">
        <ion-label class="font-20 ion-no-margin" color="dark">{{ 'LBL.total_amount' | translate }}</ion-label>
        <ion-text class="font-20" color="dark" slot="end">
          <ng-container *ngIf="total">{{ total | currency : currency : 'symbol' }}</ng-container>
          <ng-container *ngIf="!total">{{ 'PAYMENT.type.free' | translate }}</ng-container>
        </ion-text>
      </ion-item>
      <div class="ion-margin">
        <ion-button expand="block" (click)="checkUserLogin()" [disabled]="!currency || !itemList?.length || (voucher?.minQty > 0 && voucher.minQty > totalQty) || (voucher?.maxQty > 0 && totalQty > voucher.maxQty)">
          <ion-text class="ion-text-wrap">{{ 'BTN.next' | translate }}</ion-text>
        </ion-button>
        <div class="ion-text-center">
          <ion-text class="font-12 font-underline" (click)="goAccountComparisonPage()">{{ 'PRODUCT_COMPARE.title' | translate }}</ion-text>
        </div>
      </div>
    </div> 
  </ion-toolbar>
</ion-footer>
